import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import MetricValueForm from '../MetricValueForm';

function MetricValueEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <MetricValueForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </MetricValueForm>
    </Edit>
  );
}

export default MetricValueEdit;
